// src/components/ProductForm.js
import React, { useState } from 'react';
import styled from 'styled-components';
import axios from '../axiosConfig';

const ProductForm = ({ onProductAdded, onClose }) => {
  const [newProduct, setNewProduct] = useState({ product_title: '', price: '', product_description: '', stock: '' });
  const [files, setFiles] = useState([]);

  const handleFileChange = (e) => {
    setFiles(e.target.files);
  };

  const handleAddProduct = async () => {
    if (newProduct.product_title.trim() === '' || newProduct.price.trim() === '') return;

    const formData = new FormData();
    formData.append('product_title', newProduct.product_title);
    formData.append('price', newProduct.price);
    formData.append('product_description', newProduct.product_description);
    formData.append('stock', newProduct.stock);

    Array.from(files).forEach(file => {
      formData.append('files', file);
    });

    try {
      await axios.post('/store/products', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      setNewProduct({ product_title: '', price: '', product_description: '', stock: '' });
      setFiles([]);
      onProductAdded();
    } catch (err) {
      console.error('Failed to add product', err);
    }
  };

  return (
    <Container>
      <Header>
        <h2>Add New Product</h2>
        <CloseButton onClick={onClose}>Close</CloseButton>
      </Header>
      <ProductFormContainer>
        <Input
          type="text"
          value={newProduct.product_title}
          onChange={(e) => setNewProduct({ ...newProduct, product_title: e.target.value })}
          placeholder="Título do produto"
        />
        <Input
          type="text"
          value={newProduct.price}
          onChange={(e) => setNewProduct({ ...newProduct, price: e.target.value })}
          placeholder="Preço do produto"
        />
        <Input
          type="text"
          value={newProduct.product_description}
          onChange={(e) => setNewProduct({ ...newProduct, product_description: e.target.value })}
          placeholder="Descrição"
        />
        <Input
          type="text"
          value={newProduct.stock}
          onChange={(e) => setNewProduct({ ...newProduct, stock: e.target.value })}
          placeholder="Quantidade em estoque"
        />
        <Input
          type="file"
          value={newProduct.files}
          multiple
          onChange={handleFileChange}
        />
        <AddButton onClick={handleAddProduct}>Add Product</AddButton>
      </ProductFormContainer>
    </Container>
  );
};

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
`;

const CloseButton = styled.button`
  padding: 10px;
  background-color: #ff4c4c;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #ff3333;
  }
`;

const ProductFormContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 5px;
`;

const AddButton = styled.button`
  padding: 10px;
  background-color: #4caf50;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;

  &:hover {
    background-color: #45a049;
  }
`;

export default ProductForm;
